import { useTranslation } from "react-i18next";
import FacebookLogin from "react-facebook-login";
import AppleSignin from "react-apple-signin-auth";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { appleClientId, getAppleredirectUri, getFacebookClientId } from "../../utils/general-config";
import GoogleCaptcha from "./captcha";
import { sanitizeHtml } from "../../utils/general-config";
const LegalSimpliSignUp = ({
  onSignUp,
  navigateSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  emailError,
  errorCount,
  emailErrorMsg,
  passwordError,
  passwordErrorMsg,
  loginError,
  loginErrorMessage,
  onEmailChangeHandler,
  onPwdChangeHandler,
  onPasswordKeyPress,
  emailId,
  pwd,
  termsOfUse,
  privacyPolicy,
  isCaptchaVisible,
  handleCaptchaSuccess,
  appleLogin,
}) => {
  const { t } = useTranslation();
  let redirctUri = getAppleredirectUri();

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_up.ls.description_meta")} />
        <title>{t("page_title.ls.sign_up")}</title>
      </Helmet>
      <section className="main-content px-4 md:px-0">
        <div className="flex flex-col h-full">
          <div className="container mx-auto">
            <div className="flex flex-col md:flex-row">
              <div className="w-full lg:w-1/2 flex flex-col items-center justify-center gap-4 mt-5 md:-mt-20 order-2 md:order-1">
                <p className="max-[370px]:text-[20px] text-2xl text-[#16283D] font-bold leading-[120%] text-center mb-6">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(t("sign_up.ls.img_heading")),
                    }}
                  ></span>
                </p>
                <img
                  src={process.env.PUBLIC_URL + "/static/images/signup-new-img.svg"}
                  alt="Sign Up"
                  className="max-w-full h-auto mb-6 md:mb-0"
                />
                <img
                  src={process.env.PUBLIC_URL + "/static/images/rating-new-img.svg"}
                  alt="Rating"
                  className="hidden max-w-full h-auto"
                />
                <p className="hidden text-center text-[#58666E] leading-[100%] font-normal text-[15px]">
                  {t("sign_up.ls.review_text")}
                </p>
                <img
                  src={process.env.PUBLIC_URL + "/static/images/trust-score-img.svg"}
                  alt="Trust Score"
                  className="hidden max-w-full h-auto mb-11 md:mb-0"
                />
              </div>

              <div className="w-full lg:w-1/2 flex items-center justify-center order-1 md:order-2">
                <div className="form-wrap border border-[#FF6600] rounded-[10px] !p-4 md:!p-10 gap-5 shadow-[4px_4px_10px_0px_#0000000D]">
                  <hgroup className="text-center">
                    <h1 className="main-headline text-[#16283D] !font-rethink text-2xl md:text-4xl font-bold mt-0 pb-2">
                      {t("sign_up.ls.save_document")}
                    </h1>
                    <h6 className="!text-[#16283D] !text-base md:!text-lg !font-semibold mb-1 px-0 md:px-24 mt-[-8px] md:mt-0 !mb-4">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(t("sign_up.ls.sub_content")),
                        }}
                      ></span>
                    </h6>
                  </hgroup>

                  {/* <div className="social-login ">
                    <div className="social-login--google">
                      <button
                        type="button"
                        id="googleBtn"
                        className="google-login-button text-white"
                        onClick={googleLogin}
                      >
                        <div className="bg-white m-px rounded-sm">
                          <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} />
                        </div>
                        <span> {t("sign_in.signin_with_google")}</span>
                      </button>
                    </div>
                    <div className="social-login--facebook">
                      <FacebookLogin
                        appId={getFacebookClientId()}
                        fields="name,email"
                        textButton={t("sign_in.signin_with_fb")}
                        callback={responseFacebook}
                        icon={
                          <img
                            src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                            className="facebook-login-button"
                            id="fbBtn"
                          />
                        }
                      />
                    </div>
                  </div> */}

                  {/*  this part is commented because we don't have Apple key for LegalSimpli now, so 
                    using old social media login. Once we will get the key , this commented part will be used for social media login (according to new figma)*/}

                  <div className="social-login  justify-between flex-col w-full">
                    <div className="flex items-center">
                      <div className="social-login--google w-full mb-0">
                        <button
                          type="button"
                          className="google-login-button text-xs lg:text-sm text-white !bg-[#4181EF] mt-[1px] w-auto !flex items-center justify-center h-[41px] rounded-[5px]"
                          onClick={googleLogin}
                          id="googleBtn"
                        >
                          <div className="bg-white ml-[2px] rounded-l-md rtl:hidden">
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                              height="20px"
                              width="20px"
                            />
                          </div>
                          <span className="text-sm lg:text-base rtl:ml-0 ml-10 !font-rethink">
                            {t("sign_in.signin_with_google")}
                          </span>{" "}
                          <div className="bg-white ml-[2px] rounded-r-md !right-0 !left-auto mr-[1px] ltr:hidden">
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                              height="20px"
                              width="20px"
                            />
                          </div>
                        </button>
                      </div>
                      <div className="social-login--facebook !leading-none mb-0 rtl:mr-1 ">
                        <FacebookLogin
                          appId={getFacebookClientId()}
                          autoLoad={false}
                          fields="name,email"
                          textButton=""
                          callback={responseFacebook}
                          cssClass=""
                          size="!w-[41px] !h-[40px] "
                          icon={
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                              className="facebook-login-button border border-[#EAEBED] !w-[41px] !h-[40px]  !relative !rounded-[5px]"
                              id="fbBtn"
                            />
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="social-login--apple w-full">
                      <AppleSignin
                        className="apple-signin-button"
                        authOptions={{
                          clientId: appleClientId(),
                          scope: "email name",
                          redirectURI: redirctUri + "signin-apple",
                          usePopup: true,
                        }}
                        onSuccess={appleLogin}
                        onError={(error) => {
                          console.error("Apple login failed:", error);
                          appleLogin({
                            user: null,
                            authorization: {
                              id_token: null,
                              error: error.message,
                            },
                          });
                        }}
                        uiType="light"
                        buttonExtraChildren={null}
                        style={{ display: "none" }}
                      />
                      <button
                        // onClick={() => document.querySelector(".apple-signin-button").click()}
                        className="relative flex items-center justify-center px-2.5 py-2 border border-[#EAEBED] bg-white cursor-pointer rounded-md w-full -mt-[6px]"
                      >
                        <img
                          src={process.env.PUBLIC_URL + "/static/images/apple-icon.svg"}
                          alt="Apple"
                          className="absolute left-3 w-5 h-6"
                        />
                        <span className="text-center w-full ml-5">{t("sign_in.signin_with_apple")}</span>
                      </button>
                    </div> */}
                  </div>

                  <div className="form-text mb-1">
                    <>
                      {emailError && <p className="text-center  text-red-600">{emailErrorMsg}</p>}
                      {passwordError && !emailError && <p className="text-center  text-red-600">{passwordErrorMsg}</p>}
                      {loginError && <p className="text-center  text-red-600">{loginErrorMessage}</p>}
                    </>
                  </div>

                  <div
                    className="max-w-[220px] flex items-center w-full relative gap-5 mx-auto my-6"
                    role="separator"
                    aria-label="Email sign up divider"
                  >
                    <div className="flex-1 h-px bg-gradient-to-r from-white to-[#687585]" />
                    <div className="text-[18px] text-[#687585] font-rethink">or</div>
                    <div className="flex-1 h-px bg-gradient-to-r from-[#687585] to-white" />
                  </div>

                  <div className="form-container">
                    <div className="form-group">
                      {/* <div className="form-text mb-2">
                        {emailError && (
                          <p key="pswrdErr" role={alert} className="text-red-600 text-center w-full">
                            <h2> {errorCount + t("sign_up.signup_alert_text")}</h2>
                            <br />
                            {emailError && (
                              <li>
                                <small key="pswrdErr">{emailErrorMsg}</small>
                              </li>
                            )}

                            {passwordError && (
                              <li>
                                <small key="pswrdErrw">{passwordErrorMsg}</small>
                              </li>
                            )}

                            {loginError && (
                              <li>
                                <small key="pswrdErrww">{loginErrorMessage}</small>
                              </li>
                            )}
                          </p>
                        )}
                      </div> */}
                      <InputText
                        showLabel={false}
                        id="email"
                        text="Email Address"
                        onChange={onEmailChangeHandler}
                        value={emailId.trim()}
                        maxLength={100}
                        className="border-gray-300 rounded  p-2 border mb-3 max-w-96 !font-rethink"
                        placeholder={t("sign_up.ls.placeholder_email")}
                      />
                    </div>
                    {/* <div className="form-text">
                      {emailError && (
                        <small key="pswrdErr" className="text-red-500 font-sm">
                          {emailErrorMsg}
                        </small>
                      )}
                    </div> */}
                    <div className="form-group">
                      <InputText
                        showLabel={false}
                        id="password"
                        text="Password"
                        type="password"
                        className="border-gray-300 rounded  p-2 border mb-3 max-w-96 !font-rethink"
                        onChange={onPwdChangeHandler}
                        value={pwd}
                        onKeyPress={onPasswordKeyPress}
                        placeholder={t("sign_up.ls.placeholder_password")}
                      />
                    </div>
                    {/* <div className="form-text">
                      {passwordError && (
                        <small key="pswrdErr" className="text-red-500 font-sm">
                          {passwordErrorMsg}
                        </small>
                      )}
                    </div>

                    <div className="form-text">
                      {loginError && (
                        <small key="pswrdErr" className="text-red-500 font-sm">
                          {loginErrorMessage}
                        </small>
                      )}
                    </div> */}
                    <p className="text-xs max-[370px]:text-[9.5px] md:text-sm leading-[1.4] text-center max-w-[332px] text-[#687585] font-rethink mb-6 mx-auto">
                      {t("sign_up.ls.by_continuing")}{" "}
                      <a
                        href={termsOfUse}
                        className="text-[#0e76ff] underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("sign_up.ls.term_of_use")}
                      </a>{" "}
                      {t("sign_up.ls.and")}{" "}
                      <a
                        href={privacyPolicy}
                        className="text-[#0e76ff] underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("sign_up.ls.privacy_policy")}
                      </a>
                    </p>
                    <div className="md:relative bottom-0 left-0 bg-white border-gray-300 p-0 md:pt-[5px] text-center w-full z-50">
                      <button
                        className="rounded-full bg-[#16283D] items-center justify-center py-3 md:py-3 px-20 md:px-[9.5rem] text-center max-[340px]:text-[16px] text-lg font-bold text-white font-rethink uppercase"
                        isLoading={false}
                        id="signUpButton"
                        disabled={disableBtn}
                        onClick={onSignUp}
                      >
                        {t("sign_up.ls.headline")}
                      </button>
                    </div>
                    <p className="mt-5 text-center text-[#16283D] text-xs md:text-sm font-rethink">
                      <span>{t("sign_up.ls.member_already")}</span>{" "}
                      <button
                        className="text-[#0E76FF] font-normal  text-xs md:text-sm font-rethink"
                        runat="server"
                        id="alreadyHaveAnAccount"
                        isLoading={false}
                        disabled={disableBtn}
                        onClick={navigateSignIn}
                      >
                        <i>
                          <FontAwesomeIcon icon={""} className="text-center" />
                        </i>{" "}
                        {t("sign_up.ls.login")}
                      </button>
                    </p>
                    <div>{isCaptchaVisible && <GoogleCaptcha onCaptchaSuccess={handleCaptchaSuccess} />}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LegalSimpliSignUp;
